<script setup>
import { ref, reactive } from "vue";

const props = defineProps([
  "label",
  "markPostfix",
  "min",
  "max",
  "minInputWidth",
  "step",
  "minWith",
  "modelValue",
]);
const emit = defineEmits(["update:modelValue"]);

const slider = ref([...props.modelValue]);

const generateMarks = (startValue, endValue) => {
  let marks = {};
  const middleValue = Number(((startValue + endValue) / 2).toFixed(0));
  marks[startValue] = `${startValue} ${props.markPostfix}`;
  marks[middleValue] = `${middleValue} ${props.markPostfix}`;
  marks[endValue] = `${endValue} ${props.markPostfix}`;
  return marks;
};

const sliderMarks = reactive(generateMarks(props.min, props.max));

const leftRangeNum = ref(props.min);
const handleLeftRangeChange = (value) => {
  setSliderValue("left", value);
};

const rightRangeNum = ref(props.max);
const handleRightRangeChange = (value) => {
  setSliderValue("right", value);
};

const setSliderValue = (side, value) => {
  let sliderValue = slider.value;
  if (side == "left" && sliderValue[0] <= sliderValue[1])
    sliderValue[0] = value;
  if (side == "right" && sliderValue[1] >= sliderValue[0])
    sliderValue[1] = value;
  slider.value = sliderValue;
  emit("update:modelValue", slider.value);
};

const handleSliderRangeChange = (value) => {
  leftRangeNum.value = value[0];
  rightRangeNum.value = value[1];
  emit("update:modelValue", value);
};

// Метод для сброса значений слайдера
const resetSlider = () => {
  slider.value = [props.min, props.max];
  leftRangeNum.value = props.min;
  rightRangeNum.value = props.max;
  emit("update:modelValue", slider.value);
};

// Отслеживаем изменения props, если они могут измениться после первого рендера
watch(
  () => props.modelValue,
  (newValue) => {
    slider.value = [...newValue];
    leftRangeNum.value = newValue[0];
    rightRangeNum.value = newValue[1];
  },
  { immediate: true }
);
</script>

<template>
  <div
    class="slider-size-block custom-range-slider"
    :style="{
      minWidth: $device.isDesktop
        ? props.minWith
        : `${parseInt(props.minWith) * 0.8}px`,
    }"
  >
    <span v-if="$device.isDesktop">{{ props.label }}</span>

    <el-input-number
      size="small"
      v-model="leftRangeNum"
      :min="props.min"
      :max="rightRangeNum"
      @change="handleLeftRangeChange"
      :precision="0"
      :step="props.step"
      class="range-input-number-left"
      :style="{
        minWidth: props.minInputWidth,
        marginLeft: $device.isMobile ? '0' : '10px',
      }"
    />

    <el-slider
      range
      v-model="slider"
      :marks="sliderMarks"
      :min="props.min"
      :max="props.max"
      @change="handleSliderRangeChange"
      :step="props.step"
    />

    <el-input-number
      size="small"
      v-model="rightRangeNum"
      :min="leftRangeNum"
      :max="props.max"
      @change="handleRightRangeChange"
      :precision="0"
      :step="props.step"
      class="range-input-number-right"
      :style="{ minWidth: props.minInputWidth }"
    />
  </div>
</template>

<style scoped>
.slider-size-block {
  /* background-color: antiquewhite; */
  display: flex;
  align-items: center;
}

.slider-size-block .el-slider {
  margin-top: 0;
  margin-left: 12px;
}

.range-input-number-left {
  /* min-width: 80px; */
  margin-left: 10px;
  margin-right: 5px;
}

.range-input-number-right {
  /* min-width: 80px; */
  margin-left: 20px;
  margin-right: 30px;
}
</style>
